<template>
	<article class="small-12 listing residentListing bgWhite border light borderRadius4 flex vertical-align animated fadeIn" v-bind:class="{ active: isActive }" v-if="lease && resident">
		<router-link :to="{ name: 'LeaseRent', params: { id: lease.relationships.property, residentID: resident.id, leaseID: lease.id } }" class="flex small-12">
			<div class="small-12 large-5 columns flex vertical-align">
				<p class="small-12 text-overflow transition flex vertical-align">
					<picture class="avatar round flex justify-center vertical-align bgPrimaryBlue cWhite" :style="avatarBackgroundStyle" v-if="resident && resident.links.avatar"></picture> 
					<picture class="avatar round flex justify-center vertical-align bgPrimaryBlue cWhite" v-else>
						<span>{{lease.attributes.resident.first_name | abbreviateName}} {{lease.attributes.resident.last_name | abbreviateName}}</span>
					</picture> 
					<span class="small-9">
						<b class="small-12 text-overflow">{{start_year}} - {{end_year}}</b>
						<span class="small-12 float-left termDate" v-if="start_year !== end_year">$600.00/mo.</span>
					</span>
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align">
				<p class="small-12 text-overflow">
					{{lease.attributes.unit.number}}
				</p>
			</div>
			<div class="small-12 large-2 columns flex vertical-align">
				<p class="small-12 text-overflow">
					<span class="badge cYellow borderRadius4" v-if="lease.attributes.status == 'pending'">Pending</span>
					<span class="badge bgPrimaryBlue borderRadius4" v-else-if="lease.attributes.status == 'active'">Active</span>
					<span class="badge bgSecondaryPurple borderRadius4" v-else-if="lease.attributes.status == 'expired'">Expired</span>
					<span class="badge cGrey borderRadius4" v-else>Future</span>
				</p>
			</div>
			<div class="small-12 large-3 columns flex vertical-align justify-between">
				<p class="small-9 text-overflow cMedium transition" v-if="expiredDaysCheck">
					{{lease.attributes.details.end_date | daysLeft}} Days
				</p>
				<p class="small-9 text-overflow cMedium transition" v-else>
					--
				</p>
				<a class="border borderRadius4 flex vertical-align justify-center viewButton cMedium">
					<i class="material-icons">navigate_next</i>
				</a>
			</div>
		</router-link>
	</article>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { AbbreviateNameFilter } from '@/mixins/filters/AbbreviateNameFilter'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Lease',

		/*
		**  Register the components
		*/

		components: {

			//

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			AbbreviateNameFilter

		],

		/*
		**  Set the props
		*/

		props: {

			lease: {
				type: Object,
				default: () => null
			},

			resident: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			openMenuDropdown: false,
			isActive: false,
			unit: null,
			future_item: false,
			start_year: null,
			end_year: null

		}),

		/*
		**  Watch em'
		*/

		watch: {

			lease: {

				immediate: true, // Load on created
				handler(lease) {

					
					if (lease) {

						// Get the unit
						this.getUnit();

						// Get the lease term duration
						this.getTermDuration();

					}

				}

			}

		},

		/*
		**  Do this first
		*/

		created() {

			window.addEventListener("click", this.closeEditMenuDropdown);

		},

		/*
		**  Do this last
		*/

		beforeDestroy() {

			window.removeEventListener("click", this.closeEditMenuDropdown);

		},

        /*
		**  Set up the methods
		*/

		methods: {

			getResident: function() {

				

			},

			getUnit: function() {

				//

			},

			throwDeleteModal: function() {

				//

			},

			openEditMenuDropdown: function() {

				// Set the prop
				if (!this.openMenuDropdown) {

					// Open menu
					this.openMenuDropdown = true;

					// Set the z-index of the unit
					this.isActive = true;

				} else {

					// Open menu
					this.openMenuDropdown = false;

					// Set the z-index of the unit
					this.isActive = false;

				}

			},

			closeEditMenuDropdown: function(e) {

		    	if (!this.$el.contains(e.target)) {

		    		// Close menu
		    		this.openMenuDropdown = false;

		    		// Set the z-index of the unit
					this.isActive = false;

		    	}

			},
			
			getTermDuration: function() {

				// Set the props
				this.start_year = moment(this.lease.attributes.details.start_date * 1000).format('MM/DD/YYYY');
				this.end_year = moment(this.lease.attributes.details.end_date * 1000).format('MM/DD/YYYY');

			},

		},

		/*
		**  Set the computed props
		*/

		computed: {

			avatarBackgroundStyle: function() {

				return 'background:url(' + this.resident.links.avatar + ') no-repeat center/cover;'

			},

			expiredDaysCheck: function() {

				let expiresAt = moment(this.lease.attributes.details.end_date * 1000),
					todaysDate = moment(),
					difference = expiresAt.diff(todaysDate, 'days');

				if (difference > 0) {

					return true;

				} else {

					return false;

				}

			}

		},

		/*
		**  Set the filters
		*/

		filters: {

			daysLeft: function(value) {

				let expiresAt = moment(value * 1000),
					todaysDate = moment();

				return expiresAt.diff(todaysDate, 'days');

			}

		}

	}

</script>